import React, { useEffect, useState } from "react";
import "./special_offers.css";
import "./special_offers.scss";
import { FaMapMarkerAlt, FaCalendarAlt, FaMapMarkedAlt } from "react-icons/fa";
import truncate from "truncate-html";
import { Link } from "react-router-dom";

const SpecialOffers = () => {
  const [data, setData] = useState([]);
  const [activeTab, setActiveTab] = useState("cairo"); // Cairo افتراضي

  useEffect(() => {
    fetch("https://admin.mythsegypttours.com/api/packages-tours")
      .then((res) => res.json())
      .then((result) => {
        setData(result.data || []);
      })
      .catch((err) => console.error("Error fetching tours:", err));
  }, []);


  // هنا ممكن تضيف فلترة بناءً على activeTab
  const filteredData = data; // مؤقتًا كله نفس الداتا

  return (
    <section className="main-special-offers container section">
      <div className="secTitle">
        <span>Special Packages</span>
        <h2 className="title">Special Packages for you</h2>
        <p>
          Find the right Package before it's too late
        </p>
       
      </div>

      {/* التابات */}


      {/* المحتوى حسب التاب */}
      <div className="secContent-card grid">
        {filteredData.length > 0 ? (
    filteredData.slice(0,8).map((trip)=> {
  const firstImage = trip.images?.length
    ? `https://admin.mythsegypttours.com/storage/${trip.images[0]}`
    : "https://via.placeholder.com/400x250";

             return (
                          <div key={trip.id} className="singleDestination_popular">
                            <div className="imgDiv">
                              <img src={firstImage} alt={trip.title} />
                            </div>
                            <h5 className="desTitle">{trip.title}</h5>
            
                            <div className="cardInfo">
                              <div className="flex-container_p">
                                <span className="continent flex">
                                  <FaMapMarkedAlt className="icon_p" /> {trip.places}
                                </span>
                                <span className="continent flex">
                                  <FaCalendarAlt className="icon_p" /> {trip.days}
                                </span>
                                <span className="continent flex">
                                  <FaMapMarkerAlt className="icon_p" /> {trip.destination?.title || "No Destination"}
                                </span>

                              </div>
            
                              <div className="fees flex">
                                <div className="price">
                                  <h5>
                                    ${trip.pricings?.length > 0 
                ? Math.min(...trip.pricings.map(p => parseFloat(p.price_per_person))) 
                : "N/A"}
                                    <span>/Person</span>
                                  </h5>
                                </div>
            
                      <Link to={`/tour-details/${trip.id}`}>
              <button className="bookBtn">PACKAGE DETAILS</button>
            </Link>
            
                              </div>
                            </div>
                          </div>
                        );
            }
          )
        ) : (
          <p>Loading...</p>
        )}
      </div>
    </section>
  );
};

export default SpecialOffers;
